export default __webpack_public_path__ + "0c3584d2d44246633242c1f2ae738262.jpg";